export default "assets/mail-7040d2b1.svg";